<template>
  <div id="div-mapa" :class="{'animate-bottom': config.open, 'animate-bottom-reverse': !config.open}">
    <el-row class="header-map" v-if="config.showHeader">
      <el-col :span="20">
        <span class="title-map">Visualizar no mapa</span>
      </el-col>
      <el-col :span="4">
        <el-button class="close-map" :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}`" @click="closeMap"
                   type="text">Fechar
        </el-button>
      </el-col>
    </el-row>
    <GoogleMap
      v-if="userloc"
      :apikey="aplicacao.googleMapsApiKeyGeocodeLocation"
      :config="mapConfig"
    >
      <GoogleMapMarkers
        v-for="(item, index) in locations"
        ref="markers"
        :key="index"
        :markers="([]).concat(item.coordenadas)"
        :refObject="item.refObject"
        :user-location="userloc"
        :pin-color="pinColor"
      />
    </GoogleMap>
    <div class="slot-content">
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>

import GoogleMap from './GoogleMap'
import GoogleMapMarkers from './GoogleMapMarkers'
import { mapGetters } from 'vuex'

export default {
  name: 'Mapa',
  data () {
    return {
      copiado: false,
      userloc: null,
      open: true,
      mapConfig: {
        disableDefaultUI: true,
        center: {}
      }
    }
  },
  components: {
    GoogleMap,
    GoogleMapMarkers
  },
  props: {
    locations: {
      type: Array,
      required: true
    },
    config: {
      type: Object,
      default: () => {
        return {
          showHeader: true,
          showCardInfo: true,
          showActions: true,
          height: '200px',
          zoom: 10,
          center: {},
          gestureHandling: 'greedy',
          fullscreenControl: true
        }
      }
    },
    onMarkerClick: Function,
    pinColor: { default: '#016fb9' }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo', 'aplicacao']),
    colorButton () {
      return `background: ${this.estilo.aplicacao.corPrimariaAplicacao}`
    },
    colorBorder () {
      return `border: 1px solid ${this.estilo.aplicacao.corPrimariaAplicacao}; color: ${this.estilo.aplicacao.corPrimariaAplicacao}`
    },
    hasLocation () {
      return this.locations && this.locations.length > 0
    }
  },
  methods: {
    closeMap () {
      this.config.open = false
      setTimeout(() => {
        this.$emit('close')
      }, 400)
    },
    copyText () {
      let copyTextarea = document.querySelector('.text-card-map').innerHTML
      var text = document.createElement('input')
      document.body.appendChild(text)
      text.value = copyTextarea
      text.select()
      document.execCommand('copy', false)
      text.remove()
      this.copiado = true
      setTimeout(() => {
        this.copiado = false
      }, 500)
    },
    panToPosition (lat, lon) {
      this.$refs.markers.some(x => x.panToPosition(lat, lon))
    },
    openGmap () {
      window.open(`https://www.google.com/maps/search/?api=1&query=${this.item.coordenadas[0].lat},${this.item.coordenadas[0].long}`, '_blank')
    },
    processMarkerClick (googleMarker) {
      this.onMarkerClick(googleMarker)
    }
  },
  created () {
    this.mapConfig.center.lat = null
    this.mapConfig.center.lat = null

    if (!this.hasLocation) {
      return // Não tem localização, então ignora  o processo.
    }

    if (Array.isArray(this.locations[0].coordenadas)) {
      this.mapConfig.center.lat = this.locations[0].coordenadas[0].lat
      this.mapConfig.center.lng = this.locations[0].coordenadas[0].long
    } else {
      this.mapConfig.center.lat = this.locations[0].coordenadas.lat
      this.mapConfig.center.lng = this.locations[0].coordenadas.long
    }

    this.mapConfig.height = this.config.height
    this.mapConfig.zoom = this.config.zoom
    this.mapConfig.fullscreenControl = this.config.fullscreenControl

    navigator.geolocation.getCurrentPosition(
      position => {
        let latitude = parseFloat(position.coords.latitude)
        let longitude = parseFloat(position.coords.longitude)
        this.userloc = { lat: latitude, lng: longitude }
      },
      () => {
        this.userloc = {}
      }
    )
  }
}

</script>

<style scoped>
@keyframes animatebottom {
  from {
    bottom: -400px;
    opacity: 0;
  }

  to {
    bottom: 10px;
    opacity: 1;
  }
}

.animate-bottom-reverse {
  position: relative;
  animation: animateclose 0.4s;
}

@keyframes animateclose {
  to {
    bottom: -400px;
    opacity: 0;
  }

  from {
    bottom: 10px;
    opacity: 1;
  }
}

.mapa {
  left: 15px;
  bottom: 10px;
  width: 119%;
  background-color: white;
}

.animate-bottom {
  position: relative;
  animation: animatebottom 0.4s;
}

.header-map {
  padding-bottom: 20px;
}

.title-map {
  font-size: 20px;
  text-align: left;
  font-family: "Open Sans";
  font-weight: 600;
  color: #333333;
  line-height: 27px;
}

.close-map {
  top: 5px;
  left: 10px;
  position: relative;
  float: right;
}

.card-map {
  position: relative;
  bottom: 15px;
  z-index: 20000;
  width: 400px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 6px;
  max-height: 187px;
}

.title-card-map {
  font-size: 16px;
  text-align: left;
  line-height: 22px;
  color: #333333;
  margin-bottom: 5px;
  display: block;
}

.text-card-map {
  color: #555555;
  text-align: left;
  line-height: 15px;
  font-size: 12px;
}

.buttons-card-map {
  margin-top: 15px;
}

.button-copy {
  margin-left: 27px;
  height: 29px;
}

.button-gmap {
  height: 29px;
}

.copiado {
  background: #0000009f;
  position: relative;
  bottom: 185px;
  width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.copiado-alerta {
  color: #FFFFFF;
  display: flex;
  justify-content: center;
}

.slot-content {
  position: absolute;
  width: 100%;
  bottom: 0px;
}
</style>
